import { Card, CardContent, CardHeading } from '@/components/ui'

export const Section = ({
  title,
  hint,
  children,
}: {
  title: string
  hint: string
  children: React.ReactNode
}) => (
  <Card>
    <CardHeading title={title} description={hint} />
    <CardContent className="space-y-3">{children}</CardContent>
  </Card>
)
